import {tile as tileStrategy} from "ol/loadingstrategy";
import VectorSource from "ol/source/Vector";
import {GeoJSON} from "ol/format";
import {createXYZ} from "ol/tilegrid";
import CircleStyle from "ol/style/Circle";
import {Fill, Stroke, Style} from "ol/style";



export const gdGetVectorSource = function (featureUrl) {
    let source = new VectorSource({
        loader: function (extent) {
            let url = featureUrl + "/" + extent[0] + "/" + extent[1] + "/" + extent[2] + "/" + extent[3];
            $.ajax({
                url: url,
                async: true,
                dataType: 'json',
                success: function (response) {
                    if (response.error) {

                    } else {
                        if (response.features) {
                            var features = new GeoJSON().readFeatures(response, {
                            });
                            if (features.length > 0) {
                                source.addFeatures(features);
                            }
                        }
                    }
                },
                error: function () {
                    console.log('Ein Fehler ist aufgetreten.')
                }
            });
        },
        strategy: tileStrategy(
            createXYZ({
                tileSize: 256,
            })
        )
    })
    return source;
}



/**
 * Zeigt ein Popup auf der Karte an
 *
 * @param coordinate
 * @param title
 * @param html
 * @param bodyClass
 * @param offsetHeight
 */
export const gdShowPopup = function (coordinate, title, html, bodyClass) {
    //console.log('coordinate',coordinate);
    const element = gdPopup.getElement();
    $(element).popover('dispose');
    gdPopup.setPosition(coordinate);
    $(element).popover({
        container: element,
        placement: 'top',
        animation: true,
        offset: '0, 15',
        title: title + '<button type="button" id="gdClosePopup" class="btn btn-sm btn-secondary py-0 close" style="float: right" aria-label="Schließen">&times;</button>',
        html: true,
        sanitize: false,
        trigger: 'manual',
        //template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header gd-popover-header"></h3><div id="gdPopoverBody" class="popover-body gd-popover-body p-1 ' + bodyClass + '"></div></div>',
        content: html
    });
    $(element).popover('show');
    $('#gdClosePopup').on('click', function (evt) {
        $(element).popover('dispose');
    })
};

export var gdHidePopup = function () {
    const element = gdPopup.getElement();
    $(element).popover('dispose');
};


const green = '#01DF01';
const yellow = '#FFFF00';
const grey = '#A4A4A4';

export const gdAdresseGefoerdertStyle = function (feature) {
    let color = ((feature.get('fpiii') == 'ABG I' || feature.get('fpiii') == 'ABG II') ? green : grey);
    return new Style({
        image: new CircleStyle({
            radius: 6,
            fill: new Fill({
                color: color
            }),
            stroke: new Stroke({
                color: color
            })
        })
    })
}
export const gdAdresseGefoerdertSelectStyle = function (feature) {
    let color = ((feature.get('fpiii') == 'ABG I' || feature.get('fpiii') == 'ABG II') ? green : grey);
    return new Style({
        image: new CircleStyle({
            radius: 6,
            fill: new Fill({
                color: color
            }),
            stroke: new Stroke({
                color: 'red'
            })
        })
    })
}

export const gdStadtteilStyle = function () {
    return new Style({
        stroke: new Stroke({
            color: 'orange',
            width: 2,
        }),
        fill: null
    })
}

export const gdMaskeStyle = function () {
    return new Style({
        stroke: null,
        fill: new Fill({
            color: 'rgba(255, 255, 255, 0.8)'
        })
    })
}



